import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './Pages.css';

function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="main-bg">
      <Header />
      <div className="page-container">
        <div className="page-header">
          <h1>{t('footer.privacy')}</h1>
          <div className="page-bar"></div>
        </div>
        
        <div className="page-content">
          <div className="policy-content">
            <div className="policy-section">
              <h2>1. Informacioni që Mbledhim</h2>
              <p>ShalaAccounting mbledh informacione personale që na jepni kur:</p>
              <ul>
                <li>Na kontaktoni përmes formës së kontaktit</li>
                <li>Na dërgoni email ose na telefononi</li>
                <li>Përdorni shërbimet tona</li>
                <li>Vizitoni faqen tonë të internetit</li>
              </ul>
              <p>Informacionet që mund të mbledhim përfshijnë:</p>
              <ul>
                <li>Emrin dhe mbiemrin tuaj</li>
                <li>Adresën e emailit</li>
                <li>Numrin e telefonit</li>
                <li>Emrin e kompanisë</li>
                <li>Informacione të tjera që na jepni vullnetarisht</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>2. Si Përdorim Informacionin</h2>
              <p>Përdorim informacionet tuaja personale për:</p>
              <ul>
                <li>T'ju kontaktojmë dhe t'ju përgjigjemi kërkesave tuaja</li>
                <li>T'ju ofrojmë shërbimet që kërkoni</li>
                <li>Të përmirësojmë shërbimet tona</li>
                <li>Të dërgojmë informacione të dobishme rreth shërbimeve tona</li>
                <li>Të plotësojmë detyrimet ligjore</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>3. Ndarja e Informacionit</h2>
              <p>Nuk shitim, shkëmbejmë ose transferojmë informacionet tuaja personale me palë të treta, përveç rasteve kur:</p>
              <ul>
                <li>Kemi marrjen tuaj të qartë</li>
                <li>Kërkohet nga ligji</li>
                <li>Është e nevojshme për të ofruar shërbimet tona</li>
                <li>Mbrojmë të drejtat dhe sigurinë tonë</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>4. Siguria e Informacionit</h2>
              <p>Implementojmë masa të përshtatshme sigurie për të mbrojtur informacionet tuaja personale nga:</p>
              <ul>
                <li>Hyrja e paautorizuar</li>
                <li>Ndryshimi i paautorizuar</li>
                <li>Zbulimi i paautorizuar</li>
                <li>Shkatërrimi i paautorizuar</li>
              </ul>
              <p>Megjithatë, asnjë metodë transmetimi në internet ose ruajtje elektronike nuk është 100% e sigurt.</p>
            </div>

            <div className="policy-section">
              <h2>5. Cookies dhe Teknologji të Ngjashme</h2>
              <p>Faqja jonë përdor cookies për të përmirësuar përvojën tuaj. Cookies janë fajla të vegjël që ruhen në pajisjen tuaj dhe na ndihmojnë të:</p>
              <ul>
                <li>Mbajmë mend preferencat tuaja</li>
                <li>Analizojmë trafikun e faqes</li>
                <li>Përmirësojmë funksionalitetin</li>
              </ul>
              <p>Mund të çaktivizoni cookies në shfletuesin tuaj, por kjo mund të ndikojë në funksionalitetin e faqes.</p>
            </div>

            <div className="policy-section">
              <h2>6. Të Drejtat Tuaja</h2>
              <p>Keni të drejta të caktuara në lidhje me informacionet tuaja personale:</p>
              <ul>
                <li>Të drejta për të parë informacionet që kemi për ju</li>
                <li>Të drejta për të korrigjuar informacione të pasakta</li>
                <li>Të drejta për të fshirë informacionet tuaja</li>
                <li>Të drejta për të kufizuar përpunimin</li>
                <li>Të drejta për të transferuar informacionet tuaja</li>
              </ul>
            </div>

            <div className="policy-section">
              <h2>7. Ndryshimet në Këtë Politikë</h2>
              <p>Mund të përditësojmë këtë politikë të privatësisë nga koha në kohë. Do t'ju njoftojmë për ndonjë ndryshim të rëndësishëm duke postuar politikën e re në faqen tonë.</p>
            </div>

            <div className="policy-section">
              <h2>8. Kontaktoni Me Ne</h2>
              <p>Nëse keni pyetje rreth kësaj politike të privatësisë, na kontaktoni në:</p>
              <div className="contact-info">
                <p><strong>Email:</strong> privacy@shalaaccounting.com</p>
                <p><strong>Telefon:</strong> +383 44 220 640</p>
                <p><strong>Adresa:</strong> Prishtinë, Kosovë</p>
              </div>
            </div>

            <div className="policy-footer">
              <p><strong>Data e fundit e përditësimit:</strong> 1 Mars 2024</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy; 